import { FC } from "react";
import styles from "./New.module.scss";

const New: FC = () => {
    return (
        <div className="container">
            <section className={styles.new}>
                <div className={styles.content}>
                    <div style={{ backgroundImage: `url(/images/news/news.png)` }}></div>
                    <time dateTime="2024-10-04">04.10.2024</time>
                    <h1>We welcome you to the beta version of the nestdex website! </h1>
                    {/* <p>
      We are thrilled to announce the highly anticipated release of our latest product update, which is set to
      revolutionize the way our customers engage with our brand. Packed with innovative features and enhanced
      functionality, this update promises to take user experience to unprecedented heights.
     </p> */}
                    <h2>At the moment the following functionality is available:</h2>
                    {/*<p>
      Additionally, we have made significant improvements to the performance and speed of our product. Through extensive
      optimization efforts, we have achieved lightning-fast response times, allowing users to accomplish tasks more
      efficiently than ever before. Whether it's processing large data sets or running complex simulations, our product
      will now deliver unparalleled speed and reliability.
      <br /> Furthermore, we have expanded the integration capabilities of our product, enabling seamless connectivity
      with a wide range of third-party applications and services. This empowers our users to leverage the power of our
      product in conjunction with their existing tools, enhancing productivity and unlocking new possibilities for
      collaboration.
     </p>
     <p>
      One of the key highlights of this update is the introduction of a cutting-edge AI-powered assistant, designed to
      anticipate and cater to the unique needs of each user. With advanced machine learning algorithms, this assistant
      will provide personalized recommendations, streamline workflows, and ensure a seamless and intuitive user
      interface.
     </p>
     <p>
      In response to user feedback, we have also implemented a host of user interface enhancements, ensuring a more
      intuitive and visually appealing experience. From sleek design elements to customizable layouts, our product
      update is designed to cater to the unique preferences of each individual user, delivering a truly tailored
      experience.
     </p>
     <p>
      "We are thrilled to unveil this game-changing product update," said [Name], [Title] at [Company]. "With the latest
      advancements in technology and an unwavering commitment to user satisfaction, we believe this update will redefine
      the way our customers interact with our brand, empowering them to achieve their goals with greater ease and
      efficiency."
      <br /> The new product update is now available for all existing customers, and new users can experience its
      groundbreaking features by signing up for a free trial on our website. Join us as we embark on this exciting
      journey towards a future of endless possibilities.
     </p>
     <h2>Block quote</h2>
     <blockquote>
      We are thrilled to announce the highly anticipated release of our latest product update, which is set to
      revolutionize the way our customers engage with our brand. Packed with innovative features and enhanced
      functionality, this update promises to take user experience to unprecedented heights.
     </blockquote>
     <h2>Bulit the list</h2> */}
                    <ul>
                        <li>Personal account</li>
                        <li>NFT mint page</li>
                        <li>News and Events</li>
                        <li>Adding a wallet</li>
                        <li>Links to all resources</li>
                        <li>Referral system</li>
                    </ul>
                    {/* <h2>Numbered list</h2>
     <ol>
      <li>Mrs. Collins silently handed it to the long list</li>
      <li>The new product update</li>
      <li>Signing up for a free trial on our website</li>
      <li>With advanced machine learning algorithms</li>
      <li>This empowers our users to leverage</li>
     </ol> */}
                    <p>The next update will be October 4-7</p>
                </div>
            </section>
        </div>
    );
};

export default New;
